import React, { useEffect, useState } from "react";
import { BoomHeroMark } from "./Logo";

const STORAGE_KEY = "slurp:welcomed";

/**
 * One-shot welcome modal for first-time visitors. Shows on first page
 * load and never again — gated by a localStorage flag. Wallet-agnostic;
 * runs whether or not a wallet is connected. The ProfileGuard handles
 * the separate "you connected a wallet but have no profile" prompt.
 */
export default function WelcomeModal() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      if (localStorage.getItem(STORAGE_KEY) !== "1") setOpen(true);
    } catch {
      // localStorage blocked (private mode etc) — show once per session
      // by leaving it open. No way to persist anyway, so this is the
      // best we can do.
      setOpen(true);
    }
  }, []);

  const close = () => {
    try { localStorage.setItem(STORAGE_KEY, "1"); }
    catch { /* private mode */ }
    setOpen(false);
  };

  // Escape closes — same UX as every other modal in the app.
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === "Escape") close(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);

  if (!open) return null;

  return (
    <div className="pm-modal__bg" onClick={close} role="dialog" aria-modal="true">
      <div
        className="pm-modal pm-welcome-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src="/images/png/slurpface (1).png"
          alt=""
          className="pm-welcome-modal__face"
        />
        <div className="pm-welcome-modal__brand">
          <BoomHeroMark size={38} />
        </div>
        <p className="pm-welcome-modal__tagline">
          direct-to-DEX on Solana
        </p>
        <button
          type="button"
          className="pm-welcome-modal__cta"
          onClick={close}
        >
          Let's go
        </button>
      </div>
    </div>
  );
}
